import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useAccountBalance } from './hooks/useAccountBalance';

import styles from './styles.module.scss';

export const AccountBalance = (): ReactElement => {
  const { t } = useTranslation();
  const { currencySymbol, amount } = useAccountBalance();

  return (
    <div className={styles.container}>
      <span data-test="balance-amount-label">{t('customerBalance')}</span>
      <span data-test="balance-amount">
        {currencySymbol || ''} {amount || ''}
      </span>
    </div>
  );
};
